import { ListStyle } from '@orcar/common-d2c';
import styled, { css } from 'styled-components';

export const DivFlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled(DivFlexColumn)`
  position: sticky;
  width: 140px;
  top: 150px;
  align-self: flex-start;
`;

export const TabWrapper = styled(DivFlexColumn)`
  gap: 40px;
`;

export const TabText = styled.p<{ type: 'title' | 'tab'; selected?: boolean }>`
  ${({ type, theme }) => (type === 'title' ? theme.FONT.H3 : theme.FONT.H4)};
  margin-bottom: ${({ type }) => type === 'title' && '50px'};
  color: ${({ selected, theme }) => selected && theme.COLOR.PRIMARY};
  cursor: ${({ type }) => (type === 'tab' ? 'pointer' : 'default')};
`;

export const MyPageContentWrapper = styled(DivFlexColumn)<{
  width?: string;
  gap?: string;
  isMobile: boolean;
  hasSubTab?: boolean;
}>`
  position: relative;
  width: 792px;

  ${({ hasSubTab, isMobile, theme }) =>
    isMobile &&
    css`
      width: 100%;
      background-color: ${theme.COLOR.GREY_BG};
      padding: ${hasSubTab ? '120px 20px 0' : '60px 20px 0'};
    `}
`;

export const ReservationCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TopLine = styled.hr<{
  margin?: string;
  isMobile?: boolean;
}>`
  width: 100%;
  height: 1px;
  margin: ${({ margin }) => (margin ? margin : '30px 0')};
  border: 0;
  background-color: ${({ theme }) => theme.COLOR.GREY_05};
`;

export const TopWrapper = styled.div<{ isMobile: boolean; margin?: string }>`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin: ${({ margin }) => margin};
`;

export const ContentWrapper = styled(DivFlexColumn)<{
  gap?: number;
  margin?: string;
  padding?: string;
  isMobile?: boolean;
  hasBgColor?: boolean;
  hasCursor?: boolean;
  hasTopBorder?: boolean;
}>`
  position: relative;
  align-items: flex-start;
  width: 100%;
  gap: ${({ gap }) => gap}px;
  margin: ${({ margin }) => margin};
  padding-top: ${({ hasTopBorder }) => hasTopBorder && '60px'};
  border-top: ${({ hasTopBorder, theme }) =>
    hasTopBorder && `1px solid ${theme.COLOR.GREY_05}`};
  cursor: ${({ hasCursor }) => hasCursor && 'pointer'};
  padding: ${({ padding }) => (padding ? padding : '')};

  ${({ hasBgColor, padding, theme, isMobile }) =>
    hasBgColor &&
    css`
      height: fit-content;
      padding: ${padding ? padding : '60px 55px'};
      background-color: ${theme.COLOR.WHITE};
      border: 1px solid ${theme.COLOR.GREY_05};
      border-radius: 10px;
      box-shadow: ${isMobile && '0px 3px 10px rgba(0, 0, 0, 0.13)'};
    `}
  & li {
    ${ListStyle}
    ${({ theme }) => theme.FONT.B1}
    word-break: keep-all;
  }
`;

export const SectionTitleWrapper = styled.div<{
  isBetween?: boolean;
  hasCursor?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: ${({ isBetween }) => isBetween && 'space-between'};
  width: 100%;
  padding-bottom: 24px;
  cursor: ${({ hasCursor }) => hasCursor && 'pointer'};
`;

export const SectionTitle = styled.p<{
  isMobile?: boolean;
  margin?: string;
}>`
  margin: ${({ margin }) => margin};
  ${({ theme, isMobile }) => (isMobile ? theme.FONT.H4 : theme.FONT.H3)};
`;

export const SectionDescription = styled.p<{
  isMobile?: boolean;
}>`
  ${({ theme, isMobile }) => (isMobile ? theme.FONT.B2 : theme.FONT.B1)};
  ${({ isMobile }) =>
    isMobile &&
    css`
      font-weight: 400;
      white-space: pre-wrap;
    `}
  color: ${({ theme }) => theme.COLOR.GREY_02}
`;

export const TextButton = styled.span<{ color?: string }>`
  display: flex;
  align-items: center;
  gap: 0 5px;
  ${({ theme }) => theme.FONT.B2};
  line-height: 21px;
  color: ${({ theme, color }) => color ?? theme.COLOR.GREY_01};
  cursor: pointer;
`;

export const FlexGapWrapper = styled.div<{
  gap?: number;
  margin?: string;
  isButton?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: ${({ gap }) => gap}px;
  margin: ${({ margin }) => margin};
  cursor: ${({ isButton }) => isButton && 'pointer'};

  & > p {
    ${({ theme }) => theme.FONT.B2}
  }
`;

export const ReferralWrapper = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BannerWrapper = styled.div<{
  imgUrl: string;
  isMobile: boolean;
}>`
  width: ${({ isMobile }) => (isMobile ? '320px' : '792px')};
  height: 80px;
  background: ${({ imgUrl }) => `url(${imgUrl})`};
  background-size: 100% auto;
  background-repeat: no-repeat;
  cursor: pointer;
`;

export const ReferralCodeText = styled.p<{ fontWeight?: number }>`
  font-size: 16px;
  font-weight: ${({ fontWeight }) => fontWeight ?? 600};
`;

export const ReferralCodeButton = styled.div<{ isMobile: boolean }>`
  display: flex;
  color: ${({ theme }) => theme.COLOR.PRIMARY};
  font-size: 14px;
  font-weight: 400;
  margin-left: ${({ isMobile }) => !isMobile && '3px'};
`;

export const MyInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
`;

export const ReferralControlWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 396px;
`;

export const CountText = styled.span`
  ${({ theme }) => theme.FONT.H4}
`;

export const ConfirmWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const FinalPriceWrapper = styled.span<{ isMobile?: boolean }>`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 8px;

  & > p {
    &:first-child {
      color: ${({ isMobile, theme }) => !isMobile && theme.COLOR.GREY_02};
    }
  }
`;

export const Text = styled.p<{
  type?: 'title' | 'isPrice' | 'cancelInfo' | 'isCompany';
  margin?: string;
  isMobile?: boolean;
}>`
  ${({ margin }) => margin && `margin: ${margin}`};
  color: ${({ type, theme }) =>
    (type === 'cancelInfo' || type === 'isCompany') && theme.COLOR.GREY_02};
  ${({ type, theme, isMobile }) => {
    switch (type) {
      case 'title':
        return theme.FONT.H4;
      case 'isPrice':
        return isMobile ? theme.FONT.H3 : theme.FONT.H2;
      case 'cancelInfo':
        return isMobile ? theme.FONT.B3 : theme.FONT.B1;
      default:
        return isMobile ? theme.FONT.B3 : theme.FONT.B2;
    }
  }};
  ${({ isMobile, theme, type }) =>
    isMobile &&
    css`
      ${type === 'cancelInfo' && theme.FONT.B3};
    `};
  line-height: ${({ type }) =>
    (type === undefined || type === 'isCompany') && '16px'};
  word-break: keep-all;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 48px;
`;

export const ReviewButtonWrapper = styled.div<{ isMobile?: boolean }>`
  position: absolute;
  top: ${({ isMobile }) => (isMobile ? '23px' : '25px')};
  right: ${({ isMobile }) => (isMobile ? '20px' : '30px')};
`;

/********************* sidebar style ***********************/
export const Title = styled.h1`
  margin: 0;
  margin-bottom: 60px;
  color: ${({ theme }) => theme.COLOR.GREY_01};
  ${({ theme }) => theme.FONT.H1};
`;

export const MultiTabWrapper = styled.div`
  padding: 40px 0;
`;

export const MainTab = styled.a<{ isSelected?: boolean }>`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.FONT.H4}
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.COLOR.PRIMARY : theme.COLOR.GREY_01};

  cursor: pointer;
`;

export const SubTabWrapper = styled(DivFlexColumn)`
  margin-top: 20px;
  gap: 12px;
`;

export const SubTab = styled.a<{ isSelected: boolean }>`
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.COLOR.PRIMARY : theme.COLOR.GREY_01};

  font-weight: ${({ isSelected }) => (isSelected ? 400 : null)};
  cursor: pointer;
`;

export const CardWrapper = styled.div<{
  isMobile: boolean;
  hasIndicator?: boolean;
  isDimmed?: boolean;
  hasDday?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: ${({ isMobile, hasIndicator }) =>
    isMobile
      ? hasIndicator
        ? '288px'
        : '320px'
      : hasIndicator
        ? '564px'
        : '600px'};
  margin-top: ${({ isMobile }) => !isMobile && '10px'};
  padding: ${({ isMobile }) => (isMobile ? '20px 20px 15px 20px' : '30px')};
  border: 1px solid ${({ theme }) => theme.COLOR.GREY_05};
  background-color: ${({ isDimmed, theme }) =>
    isDimmed ? theme.COLOR.GREY_BG : theme.COLOR.WHITE};
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.LEVEL_02};
  box-shadow: ${({ isMobile }) =>
    isMobile && '0px 3px 10px 0px rgba(0, 0, 0, 0.13)'};
  opacity: ${({ isDimmed }) => isDimmed && '0.3'};
  ${({ hasDday }) =>
    hasDday &&
    css`
      position: relative;
    `}
`;

export const SubText = styled.span`
  color: ${({ theme }) => theme.COLOR.GREY_02};
  font-size: 14px;
  font-weight: 400;
`;

export const FlexWrapper = styled.div<{
  flexDirection?: string;
  gap?: number;
  width?: string;
}>`
  display: flex;
  flex-direction: ${({ flexDirection }) =>
    flexDirection ? flexDirection : 'row'};
  ${({ gap }) => gap && `gap: ${gap}px;`}
  width: ${({ width }) => (width ? width : 'auto')};
`;
